import { all } from 'redux-saga/effects';
import { getOfficeHoursSaga } from './office-hours.action';

export const officeHoursSaga = function* () {
  yield all([getOfficeHoursSaga()]);
};

export { getOfficeHours } from './office-hours.action';
export { reducer as officeHoursReducer } from './office-hours.reducer';
